import React from 'react';
import { ArrowRightIcon, FlameIcon } from 'lucide-react';
import { restaurants } from '../data/mockData';
import { RestaurantCard } from './RestaurantCard';
interface FeaturedRestaurantsProps {
  onSelectRestaurant: (id: string) => void;
}
export function FeaturedRestaurants({
  onSelectRestaurant
}: FeaturedRestaurantsProps) {
  const featured = restaurants.filter(r => r.featured).slice(0, 4);
  return <section className="py-20 px-4 bg-bg-primary" data-id="element-56">
      <div className="max-w-7xl mx-auto" data-id="element-57">
        <div className="flex justify-between items-end mb-10" data-id="element-58">
          <div data-id="element-59">
            <div className="flex items-center gap-2 mb-2" data-id="element-60">
              <FlameIcon className="w-6 h-6 text-brand-orange" data-id="element-61" />
              <h2 className="text-4xl font-heading uppercase tracking-wide text-white" data-id="element-62">
                Destacados
              </h2>
            </div>
            <p className="font-body text-text-secondary" data-id="element-63">
              Los lugares mejor valorados por nuestra comunidad
            </p>
          </div>
          <button className="hidden md:flex items-center gap-2 font-body font-semibold text-brand-gold hover:text-brand-orange transition-colors" data-id="element-64">
            Ver todos <ArrowRightIcon className="w-4 h-4" data-id="element-65" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-66">
          {featured.map((restaurant, index) => <RestaurantCard key={restaurant.id} restaurant={restaurant} onSelect={onSelectRestaurant} delay={index * 0.1} data-id="element-67" />)}
        </div>
      </div>
    </section>;
}